import { render, staticRenderFns } from "./ExclusivePakage.vue?vue&type=template&id=37da9fd5&scoped=true&"
import script from "./ExclusivePakage.vue?vue&type=script&lang=ts&"
export * from "./ExclusivePakage.vue?vue&type=script&lang=ts&"
import style0 from "./ExclusivePakage.vue?vue&type=style&index=0&id=37da9fd5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37da9fd5",
  null
  
)

export default component.exports